<template>
    <tr>
      <!-- title -->
      <td class="text-left ml-5">
        <router-link class="color-default" :to="'/case-study/' + caseStudy.slug">{{ caseStudy.title }}</router-link>
      </td>
      <td v-if="caseStudy.published == 1">
        <span class="text-success font-weight-bold">Yes</span>
      </td>
      <td v-else>
        <span class="text-danger font-weight-bold">No</span>
      </td>
      <td v-if="caseStudy.featured == 1">
        <span class="text-success font-weight-bold">Yes</span>
      </td>
      <td v-else>
        <span class="text-danger font-weight-bold">No</span>
      </td>
      <!-- controls [Update, Delete] -->
      <td>
        <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
          <span class="fas fa-ellipsis-v"></span>
        </a>
        <ul class="dropdown-menu">
          <router-link class="dropdown-item" :to="'/case-study/edit/' + this.caseStudy.slug">Update</router-link>
          <template>
            <a class="dropdown-item" v-if="caseStudy.published == 0" @click="publishing('publish')">Publish</a>
            <a class="dropdown-item" v-else @click="publishing('unpublish')">Unpublish</a>
          </template>
          <a class="dropdown-item text-danger" @click="deleteCaseStudy">Delete</a>
        </ul>
      </td>
    </tr>
  </template>
  
  <script>
    export default {
      name: "FAQRow",
      props: ["caseStudy", "pageNumber"],
      computed: {
        author: function () {
          if (typeof this.caseStudy.author === "undefined") {
            return "unknown";
          }
          return this.caseStudy.author.name;
        },
      },
      methods: {
        publishing(action) {
          this.$store
            .dispatch("caseStudy/publishing", {
              FAQ: this.caseStudy,
              action: action,
            })
            .then((response) => {
              if(response.data.data.published == 1) {
                this.$toast.success('Case study published successfully!');
              } else {
                this.$toast.success('Case study unpublished successfully!');
              }
             
            });
        },
        deleteCaseStudy() {
          this.$store.dispatch("message/update", {
            title: this.caseStudy.title,
            body: "Are you sure you want to delete this Case Study?",
            class: "danger",
            confirm: true,
          });
  
          this.$bus.$off("proceed");
          this.$bus.$once("proceed", () => {
            this.delete(this.caseStudy);
            this.$store.dispatch("message/close");
          });
        },
        delete(FAQ) {
          this.$store.dispatch("caseStudy/delete", FAQ)
            .then(() => {
              this.$parent.$parent.getCaseStudies(this.pageNumber,'');
              this.$toast.success('Case study deleted successfully!');
            })
            .catch((error) => {
              // send error message
              this.$toast.success(error.response.data.message);
            });
        },
      },
    };
  </script>
  <style scoped>
    table tr td:nth-child(1) {
      width: 35% !important;
      padding-left: 40px;
    }
  
    table tr td:nth-child(2) {
      width: 35% !important;
    }
  
    table tr td:nth-child(3) {
      width: 20% !important;
    }
  
    table tr td:nth-child(4) {
      width: 10% !important;
    }
  </style>